var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoicemail = function SvgVoicemail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.647 7.635a4.365 4.365 0 1 1 0 8.73l-.037-.001H6.352A4.366 4.366 0 1 1 10.717 12c0 1.247-.523 2.37-1.361 3.166h5.288a4.364 4.364 0 0 1 3.003-7.53m-11.295 1.2a3.166 3.166 0 1 0 .001 6.331 3.166 3.166 0 0 0-.001-6.331m11.295 0a3.165 3.165 0 1 0 0 6.33 3.165 3.165 0 0 0 0-6.33"
  })));
};
export default SvgVoicemail;